export const trimBlankString = (str: string = '') => {
	/*
	* 아웃룩을 비롯한 워드 계열에서 텍스트 복사할 때 전반적으로 나타나는 현상
	* 눈에 보이지 않지만 이 문자(​)가 포함되면 링크 동작하지 않음
	* URL인코딩하면 %E2%80%8F로 나타남
	* Reference: https://stackoverflow.com/questions/10342012/wordpress-putting-e2808e-at-the-end-of-my-url-howcome
	*/
	var replaced = str.replaceAll('​', '');
	var result = replaced.trim();
	return result;
}

function repl(node) {
	var exp = /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/i;

	var nodes=node.childNodes;
	for (var i=0, m=nodes.length; i<m; i++)
	{
			var n=nodes[i];
			if (n.nodeType==n.TEXT_NODE)
			{
					var g=n.textContent.match(exp);
					while(g) {
							var idx=n.textContent.indexOf(g[0]);
							var pre=n.textContent.substring(0,idx);
							var t=document.createTextNode(pre);
							var a=document.createElement("a");
							a.href=g[0];
							a.innerText=g[0];
							n.textContent = n.textContent.substring(idx+g[0].length);
							n.parentElement.insertBefore(t,n);
							n.parentElement.insertBefore(a,n);
							g=n.textContent.match(exp);
					}
			}
			else
			{
					repl(n);
			}
	}
}

export function addLinkToText(inputText) {
	var div = document.createElement('div');
  div.innerHTML = inputText.replace("<meta charset='utf-8'>", '').trim();

	repl(div);

	return div.innerHTML.replaceAll('<span></span>', '');
}

export function convertFontSizePtToPx(fontSizeValue:string) {
	const convertedSize:number = Math.round(Number(fontSizeValue.replace('font-size: ', '').replace('pt', '').replace(';', '')) * 1.3333);

	var result;
	switch (true) {
		case (convertedSize == 0):
			result = 0;
			break;
		case (convertedSize <= 12):
			result = 12;
			break;
		// case (convertedSize >= 26):
		// 	result = 26;
		// 	break;
		case (convertedSize == 13):
			result = 14;
			break;
		case (convertedSize == 14):
			result = 14;
			break;
		case (convertedSize == 15):
			result = 14;
			break;
		case (convertedSize == 16):
			result = 16;
			break;
		case (convertedSize == 17):
			result = 18;
			break;
		case (convertedSize == 18):
			result = 18;
			break;
		case (convertedSize == 19):
			result = 18;
			break;
		case (convertedSize == 20):
			result = 20;
			break;
		case (convertedSize == 21):
			result = 20;
			break;
		case (convertedSize == 22):
			result = 20;
			break;
		case (convertedSize == 23):
			result = 20;
			break;
		case (convertedSize == 24):
			result = 26;
			break;
		case (convertedSize == 25):
			result = 26;
			break;
		default:
			result = convertedSize;
			break;
	}

	const convertedSizeValue:string = `font-size: ${result}px`;
	return convertedSizeValue;
}

export function fontSizeAdjust(inputText) {
	const regex = /(font-size: )\d+(pt)/gi;

	if (inputText.match(regex) === null) {
		return inputText;
	}

	inputText.match(regex).forEach(element => {
		const convertedSize = convertFontSizePtToPx(element);
		inputText = inputText.replaceAll(element, convertedSize);
	})

	return inputText;
}

export function valueToNumber(value:any):number {
	if (typeof value === 'number') {
		return value;
	}

	if (typeof value === 'string') {
		if (value.includes('px')) {
			return parseFloat(value.replace('px', ''));
		}
		return parseFloat(value);
	}

	if (typeof value === 'undefined') {
		return 0;
	}

	return 0;
}

export function valueToString(value:any):string {
	if (typeof value === 'string') {
		return value;
	}

	if (typeof value === 'number') {
		return value.toString() + 'px';
	}

	return '';
}

export function urlToVideoId(url: string): string {
	// const pattern = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(shorts\/)|(embed\/)|(e\/)|(watch\?))\??v?=?([^#&?]*).*/;
  const pattern = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(shorts\/)|(embed\/)|(e\/)|(watch\?)|(\?v=))([^#&?]*).*/;
	const idMatch = url.match(pattern);
	return !!idMatch && idMatch[10].length === 11 ? idMatch[10] : '';
}

export function urlToStartTime(url: string): string {
	const pattern = /^.*((\?start?)|(\?t?)|(\&t?))=?([0-9]*).*/;
	const timeMatch = url.match(pattern);
	return !!timeMatch && !!timeMatch[5] ? timeMatch[5] : '';
}
